export default __webpack_public_path__ + "static/media/MS002.ad0d5f26.mp3";